// Reusable helpers for CRUD list pages: search bar, pagination, badges, empty state.
export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex items-start justify-between mb-6">
      <div>
        <h1 className="text-2xl font-semibold text-slate-800" data-testid="page-title">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      </div>
      <div className="flex gap-2">{actions}</div>
    </div>
  );
}

export function Toolbar({ children }) {
  return <div className="flex items-center gap-3 mb-4">{children}</div>;
}

export function SearchInput({ value, onChange, placeholder = "Search…", testId }) {
  return (
    <input
      type="text"
      value={value}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      data-testid={testId || "search-input"}
      className="w-64 rounded-md border border-slate-300 bg-white px-3 py-1.5 text-sm focus:outline-none focus:border-slate-500"
    />
  );
}

export function StatusFilter({ value, onChange }) {
  return (
    <select
      value={value ?? "all"}
      onChange={(e) => {
        const v = e.target.value;
        onChange(v === "all" ? null : v === "active");
      }}
      data-testid="filter-status"
      className="rounded-md border border-slate-300 bg-white px-2 py-1.5 text-sm"
    >
      <option value="all">All</option>
      <option value="active">Active</option>
      <option value="inactive">Inactive</option>
    </select>
  );
}

export function StatusBadge({ active }) {
  return (
    <span
      data-testid={`badge-${active ? "active" : "inactive"}`}
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${
        active ? "bg-emerald-100 text-emerald-700" : "bg-slate-200 text-slate-600"
      }`}
    >
      {active ? "Active" : "Inactive"}
    </span>
  );
}

export function Pagination({ meta, page, onPage }) {
  if (!meta) return null;
  return (
    <div className="flex items-center justify-between mt-4 text-sm text-slate-600">
      <div data-testid="pagination-meta">
        Showing page {meta.page} of {Math.max(meta.total_pages, 1)} · {meta.total} total
      </div>
      <div className="flex gap-2">
        <button
          onClick={() => onPage(Math.max(1, page - 1))}
          disabled={page <= 1}
          data-testid="pagination-prev"
          className="px-3 py-1 rounded border border-slate-300 disabled:opacity-40"
        >
          Prev
        </button>
        <button
          onClick={() => onPage(page + 1)}
          disabled={page >= meta.total_pages}
          data-testid="pagination-next"
          className="px-3 py-1 rounded border border-slate-300 disabled:opacity-40"
        >
          Next
        </button>
      </div>
    </div>
  );
}

export function EmptyState({ label, cta }) {
  return (
    <div className="border border-dashed border-slate-300 rounded-md p-8 text-center text-slate-500">
      <div className="text-sm">{label}</div>
      {cta && <div className="mt-3">{cta}</div>}
    </div>
  );
}

export function ErrorMessage({ message }) {
  if (!message) return null;
  return (
    <div className="text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-md px-3 py-2 mb-3" data-testid="form-error">
      {message}
    </div>
  );
}
